import { LmIconFilledSocialAward, LmIconOutlineSocialAward } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconSportRewardsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineSocialAward {...rest} /> : <LmIconFilledSocialAward {...rest} />;

export default IconSportRewardsCommon;
